import axios from "axios";

// Base configuration
const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL || "https://service.verifilite.com/v1",
  // baseURL: "http://localhost:2800/v1",
  // baseURL: "http://207.180.211.93:2800/v1",
  timeout: 30000, // 30 seconds
};

/**
 * Invoke API function using axios
 * @param {string} method - HTTP method (get, post, put, delete)
 * @param {string} url - API endpoint
 * @param {object} data - Request body/data
 * @param {object} options - Additional options (headers, token, etc.)
 * @returns {Promise} Axios response
 */
export const invoke = async (method, url, data = null, options = {}) => {
  const { token, headers = {}, ...otherOptions } = options;

  // Build headers
  const requestHeaders = {
    "Content-Type": "application/json",
    Accept: "application/json",
    ...headers,
  };

  // Add token to headers if provided
  if (token) {
    requestHeaders["x-api-key-combo"] = token;
  }

  // Build config
  const config = {
    method: method.toLowerCase(),
    url: `${API_CONFIG.baseURL}${url}`,
    timeout: API_CONFIG.timeout,
    headers: requestHeaders,
    ...otherOptions,
  };

  // Add data for POST, PUT, PATCH requests
  if (data && ["post", "put", "patch"].includes(method.toLowerCase())) {
    config.data = data;
  }

  try {
    const response = await axios(config);
    return response;
  } catch (error) {
    // Error handling
    if (error.response) {
      console.error("API Error Response:", {
        status: error.response.status,
        data: error.response.data,
        headers: error.response.headers,
      });
    } else if (error.request) {
      console.error("API No Response:", error.request);
    } else {
      console.error("API Request Error:", error.message);
    }
    throw error;
  }
};

export { API_CONFIG };
